import {useFormatters} from '@wallaby-ui/document';
import {Column} from 'material-table';
import * as React from 'react';
import {useMemo} from 'react';

import {UzisSimpleTable, ValueCellWithCopy} from './UzisReportTableCommon';
import {UzisReportVIIResult} from './uzisreporttypes';

type Props = {
  data: UzisReportVIIResult | undefined;
  isLoading: boolean | undefined;
  storageIdPrefix: string;
};

type TableRow = {
  rowLabel: string;
  rowNumber: string;
  low: number | string;
  medium: number | string;
  high: number | string;
};

export const UzisReportTableVII: React.FC<Props> = ({data, isLoading = true, storageIdPrefix}) => {
  const {formatFloat, t} = useFormatters();

  const tableData: TableRow[] = useMemo(() => {
    return [
      {rowLabel: 'a', rowNumber: 'b', low: '1', medium: '2', high: '3'},
      {
        rowLabel: t('total'),
        rowNumber: '71',
        low: data?.low ?? 0,
        medium: data?.medium ?? 0,
        high: data?.high ?? 0,
      },
    ];
  }, [data, t]);

  const columns: Column<TableRow>[] = useMemo(
    () => [
      {
        field: 'rowLabel',
        title: '',
        render: (rowData) => <span style={{fontWeight: 500}}>{rowData.rowLabel}</span>,
        sorting: false,
        width: '150px',
        cellStyle: {minWidth: '150px', maxWidth: '150px', width: '150px', textAlign: 'center'},
        headerStyle: {minWidth: '150px', maxWidth: '150px', width: '150px', textAlign: 'center'},
      },
      {
        field: 'rowNumber',
        title: t('reports.uzis.common.rowNumber'),
        render: (rowData) => <span style={{fontWeight: 500}}>{rowData.rowNumber}</span>,
        sorting: false,
        cellStyle: {textAlign: 'center', minWidth: '80px', color: '#9e9e9e'},
        headerStyle: {textAlign: 'center', minWidth: '80px'},
      },
      {
        field: 'low',
        title: t('hospital.network.report.charts.absolute.legend.low'),
        render: (rowData) => <ValueCellWithCopy value={rowData.low} formatInteger={formatFloat} allowString />,
        sorting: false,
        cellStyle: {textAlign: 'center', minWidth: '120px'},
        headerStyle: {textAlign: 'center', minWidth: '120px'},
      },
      {
        field: 'medium',
        title: t('hospital.network.report.charts.absolute.legend.medium'),
        render: (rowData) => <ValueCellWithCopy value={rowData.medium} formatInteger={formatFloat} allowString />,
        sorting: false,
        cellStyle: {textAlign: 'center', minWidth: '120px'},
        headerStyle: {textAlign: 'center', minWidth: '120px'},
      },
      {
        field: 'high',
        title: t('hospital.network.report.charts.absolute.legend.high'),
        render: (rowData) => <ValueCellWithCopy value={rowData.high} formatInteger={formatFloat} allowString />,
        sorting: false,
        cellStyle: {textAlign: 'center', minWidth: '120px'},
        headerStyle: {textAlign: 'center', minWidth: '120px'},
      },
    ],
    [formatFloat, t]
  );

  return (
    <UzisSimpleTable<TableRow>
      storageScrollKey={`${storageIdPrefix}.tableVII.scroll`}
      headerLabel='reports.uzis.tableVII.title'
      columns={columns}
      data={tableData}
      isLoading={isLoading}
      options={{
        rowStyle: (_rowData, index) => ({
          color: index === 0 ? '#9e9e9e' : undefined,
        }),
      }}
    />
  );
};
